import { Node } from '../class';

export class AsyncNode extends Node {
  public isAsync = false;
}
